import axiosInstance from "./axiosInstance";
import { url } from "./url"; 

export const fetchHtml5Categories = async ({ skip = 0, limit = 3 } = {}) => {
  try {
    const response = await axiosInstance.post(`${url.apiUrl}web/html5-categories/list`, {
      sortby: "order",
      sort: "asc",
      skip,
      limit,
    });
    return response.data || null;
  } catch (error) {
    console.error("Error fetching HTML5 categories:", error);
    return null;
  }
};
